export enum KeyAPIRoutes {
    GET_KEY_REQUESTS = "config:keys:counter:query",
    CONFIGURATION_COUNTER_KEY = "config:keys:counter",
    GET_HISTORY_USERS = "auth:users:query"
}
